import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "./index.scss";
import {
    buyLandC,
    getAllNfts,
} from "../contractInteraction/contractInteraction";

import { collection, doc, getDocs, setDoc } from "firebase/firestore";
import {
    auth,
    firestoredb,
    getmapdata,
    uploadImgPlot,
} from "../../firebase/firebase";
import { Modal } from "react-bootstrap";

import { useAccount, useWalletClient } from "wagmi";

import { useLocation, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import Spinner from 'react-bootstrap/Spinner';

const BuyLand = () => {
    const [userisLogged, setUserisLogged] = useState();
    const { data: signer } = useWalletClient();
    const { address } = useAccount();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState("");
    const [brandUrl, setBrandUrl] = useState("");
    const [acceptAgreement, setAcceptAgreement] = useState(false);
    const [showModal, setShowModal] = useState(true);
    const [isLoading, setisLoading] = useState(false);
    const navigate = useNavigate()
    const location = useLocation();
    const modalData = location.state;


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const { uid } = user;
                setUserisLogged(user);
            } else {
                setUserisLogged(user);
            }
        });
        return () => unsubscribe();
    }, []);

    const handleCloseModal = () => {
        setShowModal(false);
        setName("");
        setImage("");
        setDescription("");
        navigate("/map")
    };

    const handleBuyNow = async () => {
        console.log(userisLogged);
        if (userisLogged) {
            setisLoading(true)
            var validation = validationForBuy();
            console.log(validation);
            if (
                validation.descriptionerror ||
                validation.imageError ||
                validation.nameError ||
                validation.brandurl || validation.acceptAgreement
            ) {
                console.log("error");
                setisLoading(false)
            } else {
                console.log("ok");
                // console.log(modalData);

                console.log(modalData.data.finalPrice);
                console.log(modalData.data.randomNumber);

                await buyLandC(
                    modalData.data.finalPrice,
                    modalData.data.randomNumber,
                    modalData.id,
                    signer,
                    address
                )
                    .then(async (res) => {
                        console.log(res.success);
                        if (res.success) {

                            await uploadImgPlot(image, userisLogged)
                                .then(async (res) => {
                                    console.log(res);
                                    // setDownloadUrl(res)
                                    await setDoc(
                                        doc(firestoredb, "map", modalData.mapNumber),
                                        {
                                            [modalData.id]: {
                                                background: `url(${res})`,
                                                bought: true,
                                                name: name,
                                                description: description,
                                                brandUrl: brandUrl
                                            },
                                        },
                                        { merge: true }
                                    ).then(res => {
                                        console.log(res);
                                        setisLoading(false)
                                        navigate("/map")

                                    }).catch(err => {
                                        console.log(err);
                                        setisLoading(false)
                                    })
                                })
                                .catch((err) => {
                                    console.log(err);
                                    setisLoading(false)
                                });

                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setisLoading(false)
                    });
            }
        } else {
            toast("Please login");
            setisLoading(false)
        }
    };

    const validationForBuy = () => {
        var obj = { nameError: false, descriptionerror: false, imageError: false, brandurl: false, acceptAgreement: false };
        if (name == "") {
            obj.nameError = true;
            toast("Please enter name");
        }
        if (description == "") {
            obj.descriptionerror = true;
            toast("Please enter description");
        }
        if (image == "") {
            obj.imageError = true;
            toast("Please upload image");
        }
        if (brandUrl == "") {
            obj.brandurl = true;
            toast("Please enter brand url");
        }
        if (acceptAgreement == false) {
            obj.acceptAgreement = true;
            toast("Please Accept Astrality purchase Agreement");
        }
        return obj;
    };
    return (
        <>
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                animation={false}
                centered
                className=" purchase-modal"
                size="xl"
            >
                <Modal.Header className="modal-header" closeButton>
                    <Modal.Title className="modal-title">
                        <h2 className="body-medium ">Purchase Terms and Conitions</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    <div className="first">
                        <div className="left">
                            <div className="pioneer-land-img">
                                <label htmlFor="imagePicker">
                                    <input
                                        id="imagePicker"
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setImage(e.target.files[0])}
                                        className="d-none"
                                    />
                                    {
                                        image == "" ? <img
                                            src="\assets\images\CanvasImage.png"
                                            alt=""
                                            className="img-fluid cursor-pointer"
                                        /> : <img
                                            src={URL.createObjectURL(image)}
                                            alt=""
                                            className="img-fluid cursor-pointer"
                                        />
                                    }

                                    <div className="heading-for-pick">
                                        <h2>Upload Image</h2>
                                    </div>

                                </label>

                            </div>
                            <div className="left-content">
                                <h3>Pioneer Land</h3>
                                <div className="icon-para d-flex align-content-center ">
                                    <img src="\assets\images\MapCanvasIcon.svg" alt="" />
                                    <p className="para text-light-green">{modalData?.id}</p>
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            <p>USDT {modalData?.data?.price}</p>
                        </div>
                    </div>

                    <div className="second">
                        <div className="mid-one">
                            <div>
                                <input type="text" placeholder="Enter Name" onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div>
                                <input type="url" placeholder="Enter Brand Url" onChange={(e) => setBrandUrl(e.target.value)} />
                            </div>
                            <div>
                                <textarea
                                    onChange={(e) => setDescription(e.target.value)}
                                    name=""
                                    id=""
                                    cols="30"
                                    rows="3"
                                    placeholder="Enter Description here"
                                ></textarea>
                            </div>

                        </div>
                        <div className="main">
                            <div className="div-1">
                                <p>Discounted Price:</p>
                                <h5>USDT {modalData?.data?.discountedPrice}</h5>
                            </div>
                            <div className="div-1">
                                <p>10% platform fee:</p>
                                <h5>USDT {modalData?.data?.totalFee}</h5>
                            </div>
                            <div className="div-1">
                                <p>5% tax:</p>
                                <h5>USDT {modalData?.data?.totalTax}</h5>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <div className="modal-footer">
                    <div className="content">
                        <p>Final Price:</p>
                        <h5>USDT {modalData?.data?.finalPrice}</h5>
                    </div>
                    <div className="for-border">
                        <div className="agree ">
                            <div className="d-flex align-items-center mt-0">
                                <label htmlFor="acceptAgreement">
                                    <input type="checkbox" name="" id="acceptAgreement" onChange={(e) => { setAcceptAgreement(e.target.checked) }} />
                                    I agree to the terms of
                                    the Astrality purchase Agreement
                                </label>
                            </div>
                            <div className="list">
                                <h5>After purchase, this asset:</h5>
                                <ul>
                                    <li>will not be tradable at initial stage</li>
                                    <li>can rent out to advertiser</li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer-btn">
                            <button className="back" onClick={handleCloseModal}>Back to Map</button>
                            {
                                isLoading ? <button className="confirm"><Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner></button> : <button className="confirm" onClick={handleBuyNow}>Confirm Purchase</button>
                            }

                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default BuyLand